import 'swiper/swiper-bundle.css';

import Vue from 'vue'
import { Swiper as SwiperClass, Pagination, Autoplay, EffectFade } from 'swiper';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
//import smoothscroll from 'smoothscroll-polyfill';
import slider from './components/base/slider.vue';
import tabsContent from './components/base/tabs-content.vue';
import contactWidget from './components/base/contact-widget.vue';
import landingMenu from './components/base/landing-menu.vue';

//smoothscroll.polyfill();

Vue.config.productionTip = false;
Vue.devtools = true;

SwiperClass.use([Pagination, EffectFade, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
new Vue({
  el: '#vueApp',
  delimiters: ['${', '}'],
  components: {
    'app-slider': slider,
    'app-tabs-content': tabsContent,
    'app-contact-widget': contactWidget,
    'app-landing-menu': landingMenu
  },
  data() {
    return{
      isLoaded: false,
      jsLang: 'en',
    }
  },
  computed:{
    isLocaleUa(){
      return this.jsLang === 'uk';
    }
  },
  methods: {
    changeLang(lang) {
      this.jsLang = lang;
      //console.log(lang, this.jsLang);
      const activeItem = document.querySelector('.lang-switch__item_active');
      activeItem.classList.remove('lang-switch__item_active');
      const newActiveItem = document.querySelector('.lang-switch__item[data-lang="'+lang+'"]');
      newActiveItem.classList.add('lang-switch__item_active');
    },
  },
  mounted() {
    this.jsLang = document.documentElement.getAttribute("lang");
    this.isLoaded = true;

    import(/* webpackChunkName: "custom-js" */ './js/custom.js');
  },
});
